'use client';
var classes = {"root":"m_5f75b09e","body":"m_5f6e695e","labelWrapper":"m_d3ea56bb","label":"m_8ee546b8","description":"m_328f68c0","error":"m_8e8a99cc"};

export { classes as default };
//# sourceMappingURL=InlineInput.module.css.mjs.map
